import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get supplier categories with filters
export const getSupplierCategories = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SupplierCategory/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching supplier categories:", error);
    throw error;
  }
};

// Save supplier category (insert or update)
export const saveSupplierCategory = async (supplierCategory) => {
  const response = await axios.post(`${BASE_URL}/api/SupplierCategory/save`, supplierCategory, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// Get active supplier categories for dropdown (used in other pages)
export const getActiveSupplierCategories = async () => {
  try {
    const filter = { SupplierCategory_Active: true };
    const response = await axios.post(`${BASE_URL}/api/SupplierCategory/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active supplier categories:", error);
    throw error;
  }
};
